<div class="table-wrapper">
  <div class="flex gap-4 tools header-buttons-container">
    <ng-container>
      <div class="flex align-items-center gap-2 table__action-container" (click)="openAddPopup()">
        <i class="pi pi-plus navigation-img"></i>
        <span class="vertical-align-middle table__action-button">Add</span>
      </div>
    </ng-container>
    <div class="flex align-items-center gap-2 table__action-container" (click)="refresh()">
      <i class="pi pi-refresh navigation-img"></i>
      <span class="vertical-align-middle table__action-button">Refresh</span>
    </div>
  </div>

  <div class="users-table">
    <app-table
      [value]="registeredCompanies"
      [lazy]="true"
      [fields]="fields"
      [hasMenuPermission]="hasWriteRegisteredCompanyPermission || hasDeleteRegisteredCompanyPermission"
      [totalRecords]="totalRecords"
      [menuItems]="items"
      [paginator]="false"
      [rowsLimit]="REGISTERED_COMPANIES_LIMIT"
      [showCurrentPageReport]="false"
      [loading]="loading"
      (onToggleMenu$)="initMenuItems($event)"
      (onLazyLoad$)="initRegisteredCompanies($event)"
      [contextMenuItems]="items"
      [(selectedItem)]="selectedRegisteredCompany"
      (selectedItemChange)="initCmItems()"
    ></app-table>
  </div>
</div>
